/* Kabreur search overlay — everything stays in the overlay.
   Live predictive results while typing; Enter / chips / "View all" load the
   FULL result set into the overlay (Section Rendering API). The only way out
   of the overlay is clicking a product (goes to the product page). */
(function () {
  'use strict';
  /* Own guard — must NOT reuse __kbSearchBound, which the header's inline
     open/close script may already have set (that would bail this file and
     kill the input / submit / chip logic). */
  if (window.__kbSearchDrawerJS) return;
  window.__kbSearchDrawerJS = true;
  window.__kbSearchBound = true; /* also claim the legacy flag so a leftover header inline script no-ops */

  var SUGGEST = '/search/suggest.json';
  var FULL_SECTION = 'search-overlay-results';
  var timer = null, predCtrl = null, fullCtrl = null;

  function getDrawer() { return document.querySelector('[data-search-drawer]'); }

  /* Localized UI strings passed from Liquid via data-i18n-* on the drawer. */
  function i18n(key, fallback) {
    var d = getDrawer();
    var v = d && d.getAttribute('data-i18n-' + key);
    return v || fallback;
  }

  function els() {
    var d = getDrawer();
    return d ? {
      drawer: d,
      input: d.querySelector('[data-search-input]'),
      results: d.querySelector('[data-search-results]'),
      def: d.querySelector('[data-search-default]')
    } : null;
  }

  function openDrawer(open) {
    var drawer = getDrawer();
    if (!drawer) return;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      if (drawer._sdTimer) { clearTimeout(drawer._sdTimer); drawer._sdTimer = null; }
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      var input = drawer.querySelector('[data-search-input]');
      setTimeout(function () { if (input) input.focus(); }, 120);
    } else {
      drawer.classList.remove('is-open');
      drawer._sdTimer = setTimeout(function () { drawer.hidden = true; }, 400);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showDefault() {
    var e = els(); if (!e) return;
    e.results.hidden = true;
    e.results.innerHTML = '';
    e.results.classList.remove('is-full');
    if (e.def) e.def.hidden = false;
  }

  function renderPredictive(products, q) {
    var e = els(); if (!e) return;
    if (e.def) e.def.hidden = true;
    e.results.hidden = false;
    e.results.classList.remove('is-full');
    if (!products.length) {
      e.results.innerHTML = '<p class="search-empty">' + i18n('noresults', 'No results.').replace('[[q]]', esc(q)) + '</p>';
      return;
    }
    var html = '<div class="search-results__grid">';
    products.forEach(function (p) {
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      html += '<a class="search-result" href="' + esc(p.url) + '">' +
        '<span class="search-result__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="search-result__info">' +
        '<span class="search-result__title">' + esc(p.title) + '</span>' +
        '<span class="search-result__price">' + esc(p.price || '') + '</span>' +
        '</span></a>';
    });
    html += '</div><button type="button" class="search-results__all" data-search-all>' + i18n('viewall', 'View all results') + '</button>';
    e.results.innerHTML = html;
  }

  function predictive(q) {
    if (predCtrl) predCtrl.abort();
    predCtrl = new AbortController();
    var url = SUGGEST + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
    fetch(url, { signal: predCtrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        renderPredictive((data.resources && data.resources.results && data.resources.results.products) || [], q);
      })
      .catch(function () {});
  }

  function full(q) {
    var e = els(); if (!e || !q) return;
    if (e.def) e.def.hidden = true;
    e.results.hidden = false;
    e.results.classList.add('is-full');
    e.results.innerHTML = '<div class="search-results__loading" aria-live="polite">' + i18n('searching', 'Searching…') + '</div>';
    if (fullCtrl) fullCtrl.abort();
    fullCtrl = new AbortController();
    var url = '/search?q=' + encodeURIComponent(q) + '&type=product&section_id=' + FULL_SECTION;
    fetch(url, { signal: fullCtrl.signal })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var e2 = els(); if (!e2) return;
        if (html && html.replace(/<[^>]*>/g, '').trim()) {
          e2.results.innerHTML = html;
          e2.results.scrollTop = 0;
        } else {
          /* Section not available yet — fall back to predictive so the overlay
             still shows results and never redirects or goes blank. */
          e2.results.classList.remove('is-full');
          predictive(q);
        }
      })
      .catch(function () {});
  }

  function initInput() {
    var e = els(); if (!e || !e.input) return;
    if (e.input.dataset.sdBound) return;
    e.input.dataset.sdBound = '1';
    e.input.addEventListener('input', function () {
      var q = e.input.value.trim();
      if (timer) clearTimeout(timer);
      if (!q) { showDefault(); return; }
      timer = setTimeout(function () { predictive(q); }, 220);
    });
  }

  /* Delegated clicks — survive Shopify editor re-renders */
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-search-toggle]')) { ev.preventDefault(); openDrawer(true); return; }
    var drawer = getDrawer();
    if (!drawer || drawer.hidden) return;

    if (ev.target === drawer || ev.target.closest('[data-search-close]')) { openDrawer(false); return; }

    /* "View all results" → load the full set into the overlay */
    if (ev.target.closest('[data-search-all]')) {
      ev.preventDefault();
      var e = els();
      if (e && e.input) full(e.input.value.trim());
      return;
    }

    /* Popular chips → run the search in the overlay, never navigate away */
    var chip = ev.target.closest('.search-chip');
    if (chip && drawer.contains(chip)) {
      ev.preventDefault();
      var term = '';
      try { term = new URL(chip.href, location.origin).searchParams.get('q') || ''; } catch (x) {}
      if (!term) term = (chip.textContent || '').replace(/['’]/g, '').trim();
      var ec = els();
      if (ec && ec.input) { ec.input.value = term; ec.input.focus(); full(term); }
      return;
    }
  });

  document.addEventListener('keydown', function (ev) {
    var drawer = getDrawer();
    if (ev.key === 'Escape' && drawer && !drawer.hidden) openDrawer(false);
  });

  /* Enter / submit → full results in the overlay, no redirect to /search */
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest('[data-search-form]');
    if (!form) return;
    ev.preventDefault();
    var e = els();
    var q = e && e.input ? e.input.value.trim() : '';
    if (q) full(q); else if (e && e.input) e.input.focus();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initInput);
  else initInput();
})();
